import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: !_ctx.isEdit
          ? [
              { title: 'Staff', href: '/setting/staff', color: 'primary', disabled: false },
              { title: 'Staff Account Settings', disabled: true },
            ]
          : [
              { title: 'Staff', href: '/setting/staff', color: 'primary', disabled: false },
              { title: `${_ctx.lastName} ${_ctx.firstName}`, href: `/setting/staff/${_ctx.$route.params.id}`, color: 'primary', disabled: false },
              { title: 'Staff Account Settings', disabled: true },
            ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: _ctx.$t('setting.staffAccountSettings')
    }, null, 8, ["value"]),
    _createVNode(_component_v_form, {
      modelValue: _ctx.valid,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.valid) = $event)),
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "pt-12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.category')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.category,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.category) = $event)),
                      items: _ctx.categorySelectValues,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      rules: [_ctx.required],
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.lastName')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                      rules: [_ctx.required],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.firstName')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.firstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstName) = $event)),
                      rules: [_ctx.required],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createTextVNode(_toDisplayString(_ctx.$t('setting.staffForm.staffId')) + " ", 1),
                      _createVNode(_component_v_tooltip, {
                        bottom: "",
                        color: "primary"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps({ small: "" }, props), {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode("mdi-information-outline ", -1)
                            ]))]),
                            _: 1
                          }, 16)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('setting.staffForm.staffIdTooltip')), 1),
                          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('setting.staffForm.staffIdExample')), 1),
                          _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('setting.staffForm.staffIdExampleValue')), 1),
                          _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('setting.staffForm.staffIdWarning1')), 1),
                          _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('setting.staffForm.staffIdWarning2')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                      rules: [_ctx.required, _ctx.isEmail],
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.dateOfBirth')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_date_picker, {
                      modelValue: _ctx.birth,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.birth) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.gender')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.genderSelectValues,
                      modelValue: _ctx.gender,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.gender) = $event)),
                      rules: [_ctx.required],
                      "item-title": "text",
                      "item-value": "value",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["items", "modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.address')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.address,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.phoneNumber1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.phoneNumber1,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.phoneNumber1) = $event)),
                      rules: [_ctx.isTel],
                      placeholder: _ctx.$t('setting.staffForm.phoneNumberPlaceholder'),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.phoneNumber2')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.phoneNumber2,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.phoneNumber2) = $event)),
                      rules: [_ctx.isTel],
                      placeholder: _ctx.$t('setting.staffForm.phoneNumberPlaceholder'),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "py-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.isDirector')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isDirector,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isDirector) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.isChief')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isChief,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isChief) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('setting.staffForm.isAdmin')) + " ", 1),
                      _createVNode(_component_v_tooltip, {
                        bottom: "",
                        color: "primary"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_icon, _mergeProps({ small: "" }, props), {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode("mdi-information-outline ", -1)
                            ]))]),
                            _: 1
                          }, 16)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('setting.staffForm.adminTooltip')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isAdmin,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isAdmin) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.staffCode1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.staffCode1,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.staffCode1) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.staffCode2')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.staffCode2,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.staffCode2) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.joinDate')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_date_picker, {
                      modelValue: _ctx.joinDate,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.joinDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.assignDate')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_date_picker, {
                      modelValue: _ctx.assignDate,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.assignDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.retireDate')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_date_picker, {
                      modelValue: _ctx.retireDate,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.retireDate) = $event)),
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.retireReason')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.retireSelectValues,
                      modelValue: _ctx.retireReason,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.retireReason) = $event)),
                      "item-title": "text",
                      "item-value": "value",
                      density: "compact",
                      variant: "outlined",
                      "hide-details": ""
                    }, null, 8, ["items", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.retireReasonComment,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.retireReasonComment) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      label: _ctx.$t('setting.staffForm.retireReasonDetail')
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.classInCharge')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.classes,
                      modelValue: _ctx.classesInCharge,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.classesInCharge) = $event)),
                      "item-title": "className",
                      "item-value": "classId",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      multiple: "",
                      chips: ""
                    }, null, 8, ["items", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.remarks')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.comment,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.comment) = $event)),
                      variant: "outlined",
                      label: _ctx.$t('setting.staffForm.remarks')
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('setting.staffForm.isHidden')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "6",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.isHidden,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isHidden) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    (_ctx.isEdit)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          onClick: _ctx.updateStaff,
                          loading: _ctx.loading,
                          color: "primary",
                          variant: "flat",
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"]))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          onClick: _ctx.createStaff,
                          loading: _ctx.loading,
                          disabled: !_ctx.valid,
                          color: "primary",
                          variant: "flat",
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading", "disabled"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}